import { Comment, Post } from "pages/[tenant]/g/@types";

export const localPostInfo = {
  author: {
    photo: "",
  },
  total_comments: 0,
  created_at: "",
  id: "local" as any,
  total_reactions: 0,
  user_reaction: {
    has_reaction: false,
    type: null,
  },
  reactions_per_type: {
    angry: 0,
    haha: 0,
    like: 0,
    love: 0,
    sad: 0,
    wow: 0,
  },
} as Post;

export const localCommentInfo: Comment = {
  children: [],
  comment: {
    insert: "",
  },
  created_at: "",
  id: "local" as any,
  total_reactions: 0,
  user_reaction: {
    has_reaction: false,
    type: null,
  },
  reactions_per_type: {
    angry: 0,
    haha: 0,
    like: 0,
    love: 0,
    sad: 0,
    wow: 0,
  },
} as Comment;

export const localReplyInfo: Comment = {
  children: [],
  comment: {
    insert: "",
  },
  created_at: "",
  id: "local" as any,
  total_reactions: 0,
  user_reaction: {
    has_reaction: false,
    type: null,
  },
  reactions_per_type: {
    angry: 0,
    haha: 0,
    like: 0,
    love: 0,
    sad: 0,
    wow: 0,
  },
} as Comment;
